var _excluded = ["isOpen", "isLoading", "summaryItems", "actions", "loadingText"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Group } from '../../../containers';
import { ActionsDropdownMenu } from '../../../containers/ActionsDropdownMenu/ActionsDropdownMenu';
import { Loader, Slide } from '../../../foundations';
import { useBreakpointValue } from '../../../theme';
import { zIndices } from '../../../theme/foundations';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { _IconIndicator, Box } from '../../internal';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { NakedButton } from '../NakedButton/NakedButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var actionComponentNames = [Button === null || Button === void 0 ? void 0 : Button.displayName, IconButton === null || IconButton === void 0 ? void 0 : IconButton.displayName, NakedButton === null || NakedButton === void 0 ? void 0 : NakedButton.displayName, ActionsDropdownMenu === null || ActionsDropdownMenu === void 0 ? void 0 : ActionsDropdownMenu.displayName];
export var ActionBar = forwardRef((_ref, ref) => {
  var {
    isOpen,
    isLoading,
    summaryItems,
    actions,
    loadingText
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('ActionBar', {
    isOpen
  });
  var groupVariant = useBreakpointValue({
    xs: 'vertical',
    s: 'horizontal'
  });
  var summaryItemsSpacing = useBreakpointValue({
    xs: 'none',
    s: 'm'
  });
  var actionsSpacing = useBreakpointValue({
    xs: 'xs',
    s: 's'
  });
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    __css: styles['container'],
    "data-component": "ActionBar"
  }, props), {}, {
    ref: ref,
    "aria-hidden": !isOpen,
    children: /*#__PURE__*/_jsx(Slide, {
      direction: "bottom",
      in: isOpen,
      style: {
        zIndex: zIndices.docked
      },
      children: /*#__PURE__*/_jsx(Box, {
        __css: styles['bar'],
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: isLoading ? /*#__PURE__*/_jsxs(Group, {
            alignItems: "center",
            spacing: "s",
            children: [/*#__PURE__*/_jsx(Loader, {
              color: "neutral.white"
            }), loadingText]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Group, {
              variant: groupVariant,
              spacing: summaryItemsSpacing,
              children: summaryItems === null || summaryItems === void 0 ? void 0 : summaryItems.map((_ref2, idx) => {
                var {
                  label,
                  value,
                  tooltip,
                  testId
                } = _ref2;
                return /*#__PURE__*/_jsxs(Group, {
                  spacing: "xs",
                  alignItems: "center",
                  "data-testid": testId || "action-bar-summary-item-".concat(idx),
                  children: [/*#__PURE__*/_jsx(Box, {
                    __css: styles['itemLabel'],
                    children: label
                  }), /*#__PURE__*/_jsx(Box, {
                    __css: styles['itemValue'],
                    children: value
                  }), tooltip && /*#__PURE__*/_jsx(_IconIndicator, {
                    variant: "info",
                    tooltip: tooltip,
                    isInverted: true
                  })]
                }, "".concat(label, "-").concat(idx));
              })
            }), /*#__PURE__*/_jsx(Group, {
              variant: groupVariant,
              spacing: actionsSpacing,
              children: actions === null || actions === void 0 ? void 0 : actions.map((action, idx) => {
                var {
                  displayName
                } = action.component;
                if (!(displayName && actionComponentNames.includes(displayName))) return null;
                var Comp = action.component;
                return /*#__PURE__*/_jsx(Comp, _objectSpread(_objectSpread({}, action.props), {}, {
                  "data-testid": action.testId || "action-bar-action-".concat(idx),
                  "data-inverted": true // This is a temporary prop to invert the color of the outline. Jira ticket: ME-54641

                }), "".concat(displayName, "-").concat(idx));
              })
            })]
          })
        })
      })
    })
  }));
});
ActionBar.displayName = 'ActionBar';
//# sourceMappingURL=ActionBar.js.map